import type { MessageTemplateScope } from '@/graphql/message-templates';

/**
 * What each scope means, in the words the reader needs.
 *
 * Two of the three are a person's, and the difference is a nullable column on
 * the configuration a template hangs off: `PERSON` travels with the adviser
 * between brokerages, `PERSON_IN_TENANT` is theirs under one and invisible
 * from the other. Both are private; `TENANT` is the brokerage's own.
 *
 * Keystone answers a person's two scopes as one list and does not say which
 * configuration a row belongs to, so the labels are a vocabulary for writing —
 * the split shows up on the rows only as two different `personConfigurationId`
 * values.
 */
export const SCOPE_LABELS: Record<MessageTemplateScope, string> = {
  PERSON: 'Personal — travels with you',
  PERSON_IN_TENANT: 'Personal — this brokerage only',
  TENANT: 'Brokerage — shared with everyone in it',
};
